import { Spinner, theme } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { TopDataCollectingSystemItem } from './TopDataCollectingSystemItem'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { TopSystem } from 'pages/dataSentry/interfaces'

export interface TopDataCollectingSystemsProps {
  systems: TopSystem[]
  isLoading: boolean
}

type TopSystemWithDataFlag = Partial<TopSystem> & {
  hasData: boolean
}

const PLACEHOLDER_ITEM: TopSystemWithDataFlag = { hasData: false }
const MAX_TOP_SYSTEMS = 5

export const TopUnAuthorizedSystemsCollectingData: React.FC<TopDataCollectingSystemsProps> = ({
  systems,
  isLoading,
}) => {
  const { dataTypesTotalCount } = useDataSentryContext()

  const topSystems: TopSystemWithDataFlag[] = []

  for (let i = 0; i < MAX_TOP_SYSTEMS; i++) {
    const system = systems[i]
    topSystems.push(system ? { ...system, hasData: true } : PLACEHOLDER_ITEM)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      sx={{ backgroundColor: theme.palette.Common.Container }}
      borderRadius="11px"
      px={2.5}
      py={2}
      gap={3}
    >
      <Typography variant="h4">Top Unauthorized Systems Collecting Data</Typography>

      <Box display="flex" m={3} flex={2} minHeight={360}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" flexBasis="100%">
            <Spinner size="32px" thickness={2} />
          </Box>
        ) : (
          <Box display="flex" flexWrap="wrap" justifyContent="space-evenly">
            {topSystems.map((system, index) => (
              <TopDataCollectingSystemItem
                key={system.name}
                rank={index + 1}
                name={system.name}
                code={system.code}
                logo={system.logo}
                collectionEvents={system.collectionEvents}
                dataTypeCount={system.dataTypeCount}
                trackerCount={system.trackerCount}
                hasData={system.hasData}
                totalDataTypeCount={dataTypesTotalCount}
                displayUsheredBy
                system={system.system || {}}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  )
}
